"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.scss");
require("react-quill/dist/quill.snow.css");
var TextBanner = (function (_super) {
    __extends(TextBanner, _super);
    function TextBanner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextBanner.prototype.render = function () {
        var _a = this.props, id = _a.id, customUI = _a.customUI, content = _a.content;
        return (React.createElement("div", { id: id, className: styles.textContainer, style: { backgroundColor: customUI && customUI.bgColor } },
            React.createElement("div", { dangerouslySetInnerHTML: { __html: content } })));
    };
    return TextBanner;
}(React.PureComponent));
exports.default = TextBanner;
